import { DefaultService } from '@/services/DefaultService';

//@71283 - Service para a tabela Cultivar 
export default class CultivarService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    save(cultivar, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/cultivar`, cultivar, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    find(id, contexto = "agro") {
        return this._http.get(`${this._env}/${contexto}/cultivar/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    listAllByMultipleIdsNvTecnologico(idsNvTecnologico, limit = 50, page = 0, ...params) {
        return this._http.post(`${this._env}/agro/cultivar/listbymultipleidsnvtecnologico.json?limit=${limit}&page=${page}&param=${params}`, idsNvTecnologico, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/agro/cultivar/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(column, order, page, limit, situacao, contexto = "agro", ...params) {
        return this._http.get(encodeURI(`${this._env}/${contexto}/cultivar.json?page=${page}&limit=${limit}&situacao=${situacao}&column=${column}&order=${order}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    updateSituacao(cultivar, contexto = "agro") {
        return this._http.post(`${this._env}/${contexto}/cultivar/updatesituacao`, cultivar, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAllCombo(params) {
		return this.findAllComboSituacao(1, params)
	}
    findAllComboSituacao(situacao = 1, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/cultivar/getcombo.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllComboByIdCultura(situacao = 1, idcultura, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/cultivar/getcombo/${idcultura}.json?situacao=${situacao}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}